import React from 'react';
import LoadingIndicator from '../common/LoadingIndicator';

type WithLoadingProps = {
	loading: boolean;
};

const withLoading = <P extends object>(
	Component: React.ComponentType<P>
): React.FC<P & WithLoadingProps> => {
	const WrappedComponent = ({ loading, ...props }: WithLoadingProps) => {
		return loading ? <LoadingIndicator /> : <Component {...props as P} />;
	};
	WrappedComponent.displayName = `withLoading(${Component.displayName ||
		Component.name}`;
	return WrappedComponent;
};

export default withLoading;
